module.exports = __webpack_public_path__ + "images/9b5ab1be6f0d5d15008c75c0599edfe7.svg";